/* eslint-disable no-undef */

import { API_URL } from '../../api-config';
import { useState,useEffect} from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models} from 'powerbi-client';
import axios from "axios";
import { useParams } from 'react-router-dom';
import './index.css'
const DemoBiReport = () => {
    let { id } = useParams();
    if (id =="sixbell") {
        id = "4f689b8b-bf1a-4396-949d-2b9428abade0"
    }
    if (id === "cheil"){
        id = "3a8bc423-80ce-42d8-8f97-80d834db8fec"
    }
    if (id === "demo_mineria"){
        id = "4f666e5a-55cb-4f5c-8b47-bf9d053ad42f"
    }
    if (id === "atr"){
        id = "2f3dae11-e4bb-4777-b965-b00ee32a5e85"
    }
    if (id === "demo_callcenter"){
        id = "f0a5bdce-d5c3-4d11-8486-902a491e16b9"
    }
    const [isFullscreen] = useState(true);
    const [biToken,setBiToken] = useState("");
    // const toggleFullscreen = () => {
    //   window.report.fullscreen()
    // };
    //const id = "7c743f17-b354-4660-875a-6a89d0082fa7"
    let groupId = "";
    let embedReportId = "";
    // let token = ""
    useEffect(() =>  { // Reemplaza con tu URL de API
        console.log('llegue 1')
        const fetchData = async () => {
        // await axios.post(`${API_URL}/token`, `grant_type=&username=${"sixbell@qrtsolutions.com"}&password=${"123456"}&scope=&client_id=&client_secret=`, { headers: { "Content-Type": "application/x-www-form-urlencoded" }})
        // .then((e) => {
        //     token = e.data.access_token;
        //     console.log(token);
            
            
        // }).catch((error) => {
        //     console.log(error);})

        await axios.get(`
                ${API_URL}/users-api/clients/reports/${id}`, {
                headers: {
                    "accept": "application/json",
                    // "Authorization": "Bearer " + token,
                }
                }).then((response)=>{
                    const info = response.data;
                    groupId = info.group_id
                    embedReportId = info.report_id
                    console.log(info,"INFO")
                    
                }).catch((error)=>console.log(error))
                await axios.get(`${API_URL}/users-api/clients/bi_tokens`, {
                    headers: {
                        "accept": "application/json",
                        // "Authorization": "Bearer " + token,
                    }
                }).then((response)=>{
                    setBiToken(response.data.bi_token);
                    console.log("BI TOKEN ", response.data.bi_token);
                }).catch((error) => console.log(error));
            
            }

            fetchData()
    }, []); 
    // if (token != ""){
    //   await 
    // }


    return (


            <div className = "w-screen h-screen p-12">
            {/* <div id="reportContainer"> */}
            {biToken != ""?
            <PowerBIEmbed
            embedConfig={{
                type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                id: id,
                // pageView: "fitToWidth",
                embedUrl:`https://app.powerbi.com/reportEmbed?reportId=${embedReportId}&groupId=${groupId}&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVBBQVMtMS1TQ1VTLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d`,
                accessToken: biToken,
                tokenType: models.TokenType.Aad,
                settings: {
                panes: {
                    filters: {
                    expanded: false,
                    visible: false
                    }
                    ,
                    fullscreen: isFullscreen,
                },
                }
            }}
            eventHandlers={
                new Map([
                [
                    'loaded', 
                    function () { 
                    console.log('Report loaded'); 
                    }
                ],
                [
                    'rendered', 
                    function () { 
                    console.log('Report rendered'); 
                    }
                ],
                [
                    'error', 
                    function (event) {
                    console.log(event.detail); 
                    }
                ]
                ])
            }
            cssClassName={"Embed-container"}
            getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport;
            }}
            /> :null
        }
            
            {/* </div> */}
            </div>

    )
}

export default DemoBiReport;